import React, { useState } from "react";
import { languageHelper } from "../../config/helperFunctions";

function POSNavOrderItem({
  order,
  handleSelectOrder,
  selectOrderId,
  handleOrderDetailModal,
  handleOrderDetails,
}) {
  const [orderDetail, showOrderDetail] = useState(true);
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  return (
    <div
      className="bg-d-bg-dark w-[98%] p-1 rounded-lg my-2 font-medium ml-auto cursor-default select-none"
      onClick={() => handleSelectOrder(order)}
      onDoubleClick={() => {
        handleOrderDetails(order);
        handleOrderDetailModal(true);
      }}
    >
      <span className="flex items-center justify-between w-full">
        <span className={`${selectOrderId === order.id && "text-[#838087]"}`}> Order: {order.sale_no} </span>
        <button
          onClick={() => {
            showOrderDetail(!orderDetail);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`lucide lucide-chevron-right transition-all ${
              !orderDetail ? "rotate-90" : ""
            }`}
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </span>
      <div
        className={`grid transition-all ${
          orderDetail ? "grid-rows-[0fr]" : "grid-rows-[1fr]"
        }`}
      >
        <div className="flex flex-col w-full text-sm overflow-hidden">
          <span>{languageHelper(defaultLang, "Table")}: {order.table?.name || "None"}</span>
          <span>{languageHelper(defaultLang, "Waiter")}: {order.waiter_name}</span>
          <span>{languageHelper(defaultLang, "Customer")}: {order.customer?.name}</span>
          <span>{languageHelper(defaultLang, "Phone")}: {order.customer?.phone}</span>
          <hr className="font-bold" />
          <span>{languageHelper(defaultLang, "Started Cooking")}: {order.startedCooking}</span>
          <span>{languageHelper(defaultLang, "Done")}: {order.done}</span>
          <hr />
          <span>{languageHelper(defaultLang, "Time Count")}: {order.timeCount}</span>
        </div>
      </div>
    </div>
  );
}

export default POSNavOrderItem;
